import React from "react";
import './loader.css';


export function BouncingDotsLoader (props) {
  return (
      <div className="bouncing-loader">
        <div></div>
        <div></div>
        <div></div>
      </div>
  );
};

export function ProgressLoader({ progress }) {
  return (
    <div
      className="progress-loader"
      style={{ '--progress-position': `${progress}%` }}
    ></div>
  );
}


